module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    staticClass: "sortable-table search-results table"
  }, [_c('thead', [_c('tr', _vm._l((_vm.columns), function(label, key) {
    return _c('th', {
      class: {
        active: _vm.sortKey == key
      },
      on: {
        "click": function($event) {
          _vm.sortBy(key)
        }
      }
    }, [_vm._v(_vm._s(_vm.getLabel(key))), _c('span', {
      staticClass: "arrow",
      class: _vm.sortOrders[key] > 0 ? 'asc' : 'dsc'
    })])
  }))]), _vm._v(" "), _c('tbody', _vm._l((_vm.filteredData), function(entry) {
    return _c('tr', {
      on: {
        "click": function($event) {
          _vm.performAction(entry)
        }
      }
    }, _vm._l((_vm.columns), function(label, key) {
      return _c('td', {
        domProps: {
          "innerHTML": _vm._s(_vm.renderCell(entry, key))
        }
      })
    }))
  }))])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-36c7d2ca"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/SortableTable.vue
// module id = 1093
// module chunks = 0